<template>
  <div class="divBox">
    <el-card class="box-card">
      <el-form
        ref="formValidate"
        v-loading="fullscreenLoading"
        class="formValidate mt20"
        label-width="160px"
        v-model="formValidate"
        @submit.native.prevent
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="品牌名称：" prop="brand_name">
              <el-input v-model="formValidate.brand_name"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="品牌简称：" prop="brand_sort_name">
              <el-input v-model="formValidate.brand_sort_name"  />
              <span>填写英文名称</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="品牌首字母：" prop="brand_initial">
              <el-input v-model="formValidate.brand_initial"  />
              <span>品牌名字的大写首字母，作用用字母排序</span>
            </el-form-item>
          </el-col>
          <el-col :span="24" >
            <el-form-item label="品牌LOGO：" prop="brand_image">
              <div
                class="upLoadPicBox"
                title="750*750px"
                @click="modalPicTap('1','brand_image')"
              >
                <div v-if="formValidate.brand_image" class="pictrue">
                  <img :src="formValidate.brand_image">
                </div>
                <div v-else class="upLoad">
                  <i class="el-icon-camera cameraIconfont" />
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="选择品类：" prop="cate_image">
              <div class="acea-row">
                <div
                  v-for="(item, index) in formValidate.cate_image"
                  :key="index"
                  class="pictrue"
                  draggable="false"
                  @dragstart="handleDragStart($event, item)"
                  @dragover.prevent="handleDragOver($event, item)"
                  @dragenter="handleDragEnter($event, item)"
                  @dragend="handleDragEnd($event, item)"
                >
                  <img :src="item">
                  <i
                    class="el-icon-error btndel"
                    @click="handleRemove(index)"
                  />
                  <span>{{formValidate["cate_name"][index]}}</span>
                </div>
                <div
                  v-if="formValidate.cate_image.length < 10"
                  class="uploadCont"
                  title="750*750px"
                >
                  <div class="upLoadPicBox" @click="add('2')">
                    <div class="upLoad">
                      <i class="el-icon-camera cameraIconfont" />
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="margin-top:30px;">
          <el-button :loading="loading" type="primary" class="submission" size="small" @click="handleSubmit()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!--选择品类-->
    <el-dialog v-if="visibleCateList" title="用户列表" :visible.sync="visibleCateList" width="1000px">
      <cate-list ref="cateList" v-if="visibleCateList"   @getCate="getCate" />
    </el-dialog>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { roterPre } from '@/settings'
import {
  appraisalBrandDetailApi,
  appraisalCateDetailApi, saveAppraisalBrandDataApi,
  saveAppraisalCateDataApi,
} from "@/api/appraisal";
import cateList from './cateList'
const defaultObj = {
  cate_name: [],
  cate_image: [],
  cate_id: [],
  brand_image: '',
  brand_name: '',
  brand_initial:''
}
export default {
  name: 'addCate',
  components: {cateList},
  data() {
    return {
      roterPre: roterPre,
      fullscreenLoading: false,
      formValidate: Object.assign({}, defaultObj),
      loading: false,
      grid2: {
        xl: 10,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      progress: 0,
      data: [],
      visibleCateList:false
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.getAppraisalCateData()
    }
    else
    {
      this.formValidate.cate_image = [];
      this.formValidate.cate_id = [];
      this.formValidate.cate_name = [];
    }

  },
  methods: {
    add() {
      this.visibleCateList = true
    },
    getCate(data) {
      this.formValidate.cate_image.push(data.cate_image)
      this.formValidate.cate_id.push(data.cate_id)
      this.formValidate.cate_name.push(data.cate_name)
      this.visibleCateList = false
    },
    // 移动
    handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver(e) {
      e.dataTransfer.dropEffect = "move";
    },
    handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = "move";
      if (item === this.dragging) {
        return;
      }
      const newItems = [...this.formValidate.cate_image];
      const src = newItems.indexOf(this.dragging);
      const dst = newItems.indexOf(item);
      newItems.splice(dst, 0, ...newItems.splice(src, 1));
      this.formValidate.cate_image = newItems;
    },
    handleRemove(i) {
      this.formValidate.cate_image.splice(i, 1);
      this.formValidate.cate_name.splice(i, 1);
      this.formValidate.cate_id.splice(i, 1);
    },
    // 点击图
    modalPicTap(tit,num,i) {
      const _this = this;
      const attr = [];
      this.$modalUpload(function(img) {
        if(num == 'brand_image')
        {
          _this.formValidate.brand_image = img[0];
        }
      }, tit);
    },
    // 获取数据
    getAppraisalCateData() {
      this.fullscreenLoading = true
      appraisalBrandDetailApi(this.$route.params.id)
        .then(res => {
          this.formValidate =  res.data
          this.fullscreenLoading = false
          this.loading = false
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.$message.error(res.message)
        })
    },
    // 提交
    handleSubmit() {
      if (!this.formValidate.brand_name) {
        this.$message.error('请填写品牌名称')
        return false
      }
      if (!this.formValidate.brand_initial) {
        this.$message.error('请填写品牌首字母')
        return false
      }
      this.formValidate.appraisal_brand_id = this.$route.params.id;
      saveAppraisalBrandDataApi(this.formValidate)
        .then(res => {
          this.fullscreenLoading = false
          this.$message.success(res.message)
          this.$router.push({ path: this.roterPre + '/appraisal/brand' })
          this.loading = false
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.loading = false
          this.$message.error(res.message)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.label_tip{
  display: inline-block;
  margin-left: 20px;
  color: #C0C4CC;
}
.selWidth {
  width: 100%;
}
.selWidthd {
  width: 300px;
}
.dialog-scustom,.addDia{
  min-width: 400px;
  height: 900px;
  .el-dialog{
    width: 400px;
  }
  h3{
    color: #333;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    margin: 0;
  }
}
.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
.agreement{
  width: 350px;
  margin: 0 auto;
  box-shadow: 1px 5px 5px 2px rgba(0,0,0,.2);
  padding: 26px;
  border-radius: 15px;
  .content{
    height: 600px;
    overflow-y:scroll;
    /deep/ p{
      font-size: 13px;
      line-height: 22px;
    }
  }
  /deep/ img{
    max-width: 100%;
  }
  p{
    text-align: justify;
  }
}
/*css主要部分的样式*/
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 10px; /*对垂直流动条有效*/
  height: 10px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track{
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
  background-color: transparent;
  border-radius: 3px;
}
.iview-video-style {
  width: 40%;
  height: 180px;
  border-radius: 10px;
  background-color: #707070;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}
.iconv {
  color: #fff;
  line-height: 180px;
  display: inherit;
  font-size: 26px;
  position: absolute;
  top: -74px;
  left: 50%;
  margin-left: -25px;
}
.iview-video-style .mark {
  position: absolute;
  width: 100%;
  height: 30px;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
}
.uploadVideo {
  margin-left: 10px;
}
.perW50 {
  width: 50%;
}
.submission {
  margin-left: 10px;
}
.btndel {
  position: absolute;
  z-index: 1;
  width: 20px !important;
  height: 20px !important;
  left: 46px;
  top: -4px;
}

</style>
